<ng-container *ngIf="item">
  <a
    class="d-flex align-items-center"
    *ngIf="level === 0"
    [routerLink]="!item.items ? item.routerLink : []"
    [queryParams]="!item.items ? item.queryParams : currentQueryParams"
    (click)="onClick()"
  >
    <shared-ui-icons-icon [iconName]="item.icon ?? IconType.None"></shared-ui-icons-icon>
    <span class="nav-label">{{ item.label }}</span>
    <span class="ms-auto">
      <shared-ui-icons-icon *ngIf="item.items" class="float-end" [iconName]="kidsAreDisplayed && isActive ? IconType.ChevronDown : IconType.ArrowLeft"></shared-ui-icons-icon>
    </span>
  </a>
  <a *ngIf="level !== 0" [routerLink]="!item.items ? item.routerLink : []" [queryParams]="!item.items ? item.queryParams : currentQueryParams" (click)="onClick()">
    {{ item.label }}
    <span>
      <shared-ui-icons-icon *ngIf="item.items" class="float-end" [iconName]="kidsAreDisplayed && isActive ? IconType.ChevronDown : IconType.ArrowLeft"></shared-ui-icons-icon>
    </span>
  </a>

  <ul *ngIf="item.items && isActive && kidsAreDisplayed" class="nav" [ngClass]="getLevelClass(level + 1)">
    <li shared-ui-navbars-navbar-item *ngFor="let childItem of item.items" [item]="childItem" [level]="level + 1"></li>
  </ul>
</ng-container>
